import {inject, Injectable} from '@angular/core';
import {ActivatedRouteSnapshot, Resolve, Router} from '@angular/router';
import {EMPTY, Observable} from 'rxjs';
import {ProjectDetailResponse} from '@frontend/shared-api';
import {ProjectWizardService} from './project-wizard/services/project-wizard.service';
import {catchError} from 'rxjs/operators';
import {APP_ROUTES} from '../../../app.routes';

@Injectable({providedIn: 'root'})
export class ProjectResolver implements Resolve<ProjectDetailResponse> {
  private readonly projectWizardService = inject(ProjectWizardService);
  private readonly router = inject(Router);

  resolve(route: ActivatedRouteSnapshot): Observable<ProjectDetailResponse> {
    const projectId = parseInt(route.paramMap.get('id') ?? '', 10);

    if (isNaN(projectId)) {
      console.error('Invalid or missing project ID:', route.paramMap.get('id'));
      this.router.navigate([APP_ROUTES.PROJECT]);
      return EMPTY;
    }

    return this.projectWizardService.getProjectData(projectId).pipe(
      catchError((error) => {
        console.error('Error fetching project data:', error);
        this.router.navigate([APP_ROUTES.ERROR]);
        return EMPTY;
      }),
    );
  }
}
